module.exports = __webpack_public_path__ + "img/availability-icon-active.edae3d4e.svg";